// extracted by mini-css-extract-plugin
export default {"main":"home_main__8rPfp","mystories":"home_mystories__+yKBW"};